query BatchTransactions(
  $first: Int
  $after: Cursor
  $filter: BatchTransactionFilter
  $orderBy: [BatchTransactionsOrderBy!]
) {
  batchTransactions(
    first: $first
    after: $after
    filter: $filter
    orderBy: $orderBy
  ) {
    nodes {
      id
      __typename
      _urgencyLevel
      weekNumber
      _isUpdatable
      _isDeletable
      _rowTimestamp
      referenceNumber
      description
      currencyId
      postingDate
      currency {
        isoCode
      }
      _createdByUserName
      _createdByUserid
      companyCorporatePeriod {
        _periodYear
        startDate
        endDate
      }
      corporatePeriodId
      _batchTransactionCount
      _batchTransactionTotal
      controlTotalAmount
      _isStagedApprovalRequest
      statusType {
        statusType
        _transactionIconStatus
      }
    }
    aggregates {
      sum {
        _batchTransactionCount
        _batchTransactionTotal
        controlTotalAmount
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
